import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconDownload = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	"aria-hidden": "true",
	className: "pending-pdf-modal__download-icon",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7 2v8M4 7.5l3 3 3-3",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export { SvgIconDownload as ReactComponent };
